<template>
    <div class="w-full">
        <div v-for="choice in question.options.choices" :key="choice.id" class="p-2 flex gap-2 items-center">
            <CorrectIncorrectIcon :is-correct="choice.id === question.correct_answer" />
            <LatexDisplay v-if="question.is_latex_answers" :model-value="choice.text" />
            <span v-else>{{ choice.text }}</span>
        </div>
    </div>
</template>

<script>
import CorrectIncorrectIcon from '@/components/Quiz/CorrectIncorrectIcon.vue';
import LatexDisplay from '@/components/LatexDisplay.vue';

export default {
    name: 'QuestionMultipleChoiceViewOnly',
    components: {
        LatexDisplay,
        CorrectIncorrectIcon,
    },
    props: {
        question: {
            required: true,
        },
    },
};
</script>
